import { create } from "zustand";
import {
    WorkExperienceForm,
} from "../types/workExperience";

type WorkExperienceState = {
    loading: boolean;
    updateWorkExperiences: (data: WorkExperienceForm[]) => Promise<boolean>;
};

const getAccessToken = (): string | null => {
    if (typeof window === "undefined") return null;

    try {
        const raw = localStorage.getItem("auth-storage");
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        return parsed?.state?.accessToken || null;
    } catch (e) {
        console.error("❌ Failed to parse auth token:", e);
        return null;
    }
};

export const useWorkExperienceStore = create<WorkExperienceState>((set) => ({
    loading: false,

    updateWorkExperiences: async (data) => {
        try {
            set({ loading: true });

            const token = getAccessToken();

            if (!token) {
                throw new Error("No access token found");
            }

            const payload = {
                experiences: data.map((e) => ({
                    industry_id: Number(e.industry),
                    job_type_id: Number(e.employmentType),
                    name: e.companyName,
                    job_title: e.jobTitle,
                    start_date: `${e.startDate}-31`,
                    end_date: e.current ? null : `${e.endDate}-31`,
                    is_working_here: e.current,
                    responsibility: e.responsibilities,
                    achievement: e.achievements,
                })),
            };

            const res = await fetch(
                "https://admin-talentlink.digiline.id/api/candidate/work-experiences",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!res.ok) throw new Error("Update work experience failed");

            return true;
        } catch (err) {
            console.error(err);
            return false;
        } finally {
            set({ loading: false });
        }
    },
}));
